import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import { ConfigurationService } from 'src/app/services/configuration.service';

@Component({
  selector: 'app-demander-remboursements',
  templateUrl: './demander-remboursements.component.html',
  styleUrls: ['./demander-remboursements.component.scss']
})
export class DemanderRemboursementsComponent implements OnInit {
  configuration= this.configurationService.get()
  fileLimit= this.configurationService.get().FILE.FILE_LIMIT;
  fileMaxSize= this.configurationService.get().FILE.FILE_MAX_SIZE;
  pjRequired= this.configurationService.get().FILE.MESSAGE_REQUIRED;
  fileAccept=this.configurationService.get().FILE.FILE_ACCEPT;
  fileNamePattern = new RegExp(this.configurationService.get().global.fileNamePattern);

  messageRequired=false

  constructor(private configurationService: ConfigurationService) { }

  ngOnInit(): void {
  }

}
